import { render, staticRenderFns } from "./edit-permissions.vue?vue&type=template&id=495f62ed&scoped=true"
import script from "./edit-permissions.vue?vue&type=script&lang=ts"
export * from "./edit-permissions.vue?vue&type=script&lang=ts"
import style0 from "./edit-permissions.vue?vue&type=style&index=0&id=495f62ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495f62ed",
  null
  
)

export default component.exports